import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ComplementPersonConsult from "./ComplementPersonConsult";

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: "#f0f0f0",
        padding: "20px 10px",
        textAlign: "center",
        borderTop: "1px solid #ddd",
        marginTop: "40px"
      }}
    >
      <ComplementPersonConsult />
      <br />
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} <strong>RE-CONECT</strong> — Consultoria em Gestão de Pessoas
      </Typography>
    </Box>
  );
}
